import { render, staticRenderFns } from "./Boilerplate.vue?vue&type=template&id=b6cd7bb2&scoped=true&"
import script from "./Boilerplate.vue?vue&type=script&lang=js&"
export * from "./Boilerplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6cd7bb2",
  null
  
)

export default component.exports